import { Box } from '@material-ui/core';
import React from 'react';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';

function GenericApprovalScreen({
  title = '',
  FilterComponents = () => null,
  tableData = [],
  tableDataCount = 0,
  tableColumn = [],
  handlePageChange = () => null,
  page = 1,
  perPage = 8,
}) {
  return (
    <Box py={4}>
      <Box
        borderBottom={`1px solid #dfdfdf`}
        pb={2}
        mb={4}
        fontSize={22}
        fontWeight={'fontWeightMedium'}>
        {title}
      </Box>
      <Box mb={2}>
        <FilterComponents />
      </Box>
      <BuzzTable columns={tableColumn} data={tableData} />
      <Box display="flex" justifyContent="center">
        <BuzzPagination
          onClick={handlePageChange}
          total={tableDataCount}
          pageNo={page}
          defaultPage={1}
          perPage={perPage}
        />
      </Box>
    </Box>
  );
}

export default GenericApprovalScreen;
